const HeaderKidsStyle = theme => ({
    fab: {
        margin: "0.7em",
        size: "small",
        textTransform: "none"
    },
    chip: {
        margin: "0.7em",
    },
    paperContainer: {
        backgroundImage: `url(${"https://cdn.apartmenttherapy.info/image/fetch/https://s3.amazonaws.com/pixtruder/original_images/room_search/search-by-color_17.png"})`,
        width: "100%",
        height: 200,
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQp7saXNaW4GP8TwLpJ7yfWGfNj1fDZXvJUfb03yVzLuW1HfFCM",
    }
});

export default HeaderKidsStyle;
    